import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHandlerFn, HttpHeaders, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { UsuarioService } from '../services/auth/usuario.service';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { CustomMessageService } from '../services/utils/message.service';

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {

  const usuarioService = inject(UsuarioService);
  const messageService = inject(CustomMessageService);
  const router = inject(Router);

  usuarioService.verificarCaducudadToken();

  const token: string | null = localStorage.getItem('token');
  let headers = req.headers.set('authorization', `Bearer ${token}`);
  if (req.body instanceof FormData) {
    headers = headers.delete('Content-Type');
  }

  let request = req;

  let tokenValido = !!token && token !== 'undefined' && token !== 'null';

  if (tokenValido) {
    request = req.clone({
      headers,
    });
  }

  return next(request).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 401) {
        usuarioService.logout();
        messageService.alert('La sesión ha caducado. Inicia sesión de nuevo.');
        void router.navigateByUrl('/auth/login');
      }

      return throwError(err);
    }),

    // verificar si en el body de la respuesta viene un code 401
    tap((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        if (event.body?.code === 401) {
          usuarioService.logout();
          messageService.alert('La sesión ha caducado. Inicia sesión de nuevo.');
          void router.navigateByUrl('/auth/login');
        }
      }
    })
  );
};
